// extracted by mini-css-extract-plugin
export default {"base":"input-base-module--base--mGFJt","fullWidth":"input-base-module--full-width--wvDM4"};